export const chatButtonConflictingPosition = [
  { pageName: '/pdc/', className: 'conflictingPdc' },
  { pageName: '/logomaker', className: 'conflictingLogoMaker' },
  { pageName: '/configure/quantity?', className: 'conflictingPpag' },
  { pageName: '/xs/', className: 'conflictingXS' },
  { pageName: '/acc/', className: 'conflictingXS' },
  { pageName: '/vxw-xs/', className: 'conflictingXS' },
  { pageName: '/env/', className: 'conflictingXS' },
  { pageName: '/apdc/', className: 'conflictingApdc' },
  { pageName: '/ppag-studio/', className: 'conflictingPpag' },
  { pageName: 'reseller', className: 'conflictingCta' },
  { pageName: 'configure/review', className: 'conflictingCta' },
  { pageName: '/upload-and-print/', className: 'conflictingCta' },
  { pageName: '/business-cards-connect/', className: 'conflictingCta' },
  { pageName: '/packaging-studio/', className: 'conflictingCta' },
  { pageName: '/quick-upload-and-design/', className: 'conflictingCta' },
  { pageName: 'sample-kits', className: 'conflictingSampleKits' },
  { pageName: 'mailing-landing', className: 'conflictingMailingLandingPage' },
  { pageName: 'mailing-service-review', className: 'conflictingMailingReviewPage' },
  { pageName: 'mailing-service-review', className: 'conflictingEnvelopeMailingReviewPage' },
  { pageName: 'mailing-service-envelope-review', className: 'conflictingEnvelopeMailingReviewPage' },
  { pageName: 'studio', className: 'studioPageChatButton' },
  { pageName: '/configure/team', className: 'conflictingTeamsPage' },
  { pageName: 'experts-request', className: 'conflictingBriefPage' },
];
